import React, { useEffect, useRef, useState } from 'react';
import { Pie } from 'react-chartjs-2';
import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { BiBorderRadius } from 'react-icons/bi';
import Autocomplete from '@mui/material/Autocomplete';
import { Typography, Card, TextField, InputAdornment, CircularProgress } from '@mui/material';
import LeadService from '../core/services/leadsService';
import toast from 'react-hot-toast';
import SearchIcon from '@mui/icons-material/Search';
import LogoutExpiredModal from '../components/LogoutExpiredModal';
import dayjs from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { makeStyles } from '@mui/styles';
import { useTheme } from '@mui/material/styles';
import { Grid, Paper, Stack, Button, CardContent } from '@mui/material';
import { styled } from '@mui/material/styles';
import ScrollAnimation from 'react-animate-on-scroll';
import { Avatar, Box } from '@mui/material';
import './Animation.css';
import { useMediaQuery } from '@mui/material'; // Import useMediaQuery
import BarChartIcon from '@mui/icons-material/BarChart'; // You can use any icon
import DashboardCards from './DashboardCards';
import { BsBox2Fill } from 'react-icons/bs';
import { GlobalStyles, height } from '@mui/system';
import { ThemeProvider } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
// import Agent from '../../public/statusImages/Agent.svg';
// import AppointmentSet from '../../public/statusImages/AppointmentSet.svg';
// import AttemptingContact from '../../public/statusImages/AttemptingContact.svg';
// import BadLead from '../../public/statusImages/BadLead.svg';

import Agent from '../../public/statusImages/Agent.svg';
import AppointmentSet from '../../public/statusImages/AppointmentSet.svg';
import AttemptingContact from '../../public/statusImages/AttemptingContact.svg';
import BadLead from '../../public/statusImages/BadLead.svg';
import BamFam from '../../public/statusImages/BamFam.svg';
import Cancelled from '../../public/statusImages/Cancelled.svg';
import Closed from '../../public/statusImages/Closed.svg';
import MetWithCustomer from '../../public/statusImages/MetWithCustomer.svg';
import NotIntrested from '../../public/statusImages/NotIntrested.svg';
import NurtureBeforeSale from '../../public/statusImages/NurtureBeforeSale.svg';
import NurtureAfterSale from '../../public/statusImages/NurtureAfterSale.svg';
import PersonalLead from '../../public/statusImages/PersonalLead.svg';
import RefinanceReferral from '../../public/statusImages/RefinanceReferral.svg';
import Rejected from '../../public/statusImages/Rejected.svg';
import ShowingHomes from '../../public/statusImages/ShowingHomes.svg';
import SpokeWithCustomer from '../../public/statusImages/SpokeWithCustomer.svg';
import BuySideContract from '../../public/statusImages/BuySideContract.svg';
import New from '../../public/statusImages/New.svg';
import SubmittingOffers from '../../public/statusImages/SubmittingOffers.svg';
import UnderContract from '../../public/statusImages/UnderContract.svg';
import ListingUnderContract from '../../public/statusImages/ListUnderContract.svg';
import FollowUp from '../../public/statusImages/FollowUp.svg';
import ListingSigned from '../../public/statusImages/ListingSigned.svg';
// import Broker from '../../public/statusImages/BuyerBrokerSigned.svg';
import DNC from '../../public/statusImages/DNC.svg';
import BuyerBrokerSigned from '../../public/statusImages/BuyerBrokerSigned.svg';
import ValuationAppointment from '../../public/statusImages/ValuationAppointment.svg';
// import Assigned from '../../public/statusImages/Assigned.svg';
import ListingAppointment from '../../public/statusImages/ListingAppointment.svg';
import ListUnderContract from '../../public/statusImages/ListUnderContract.svg';

const CustomTooltip = styled(({ className, ...props }) => <Tooltip {...props} classes={{ popper: className }} />)({
    '& .MuiTooltip-tooltip': {
        borderRadius: '12px',
    },
});
const useStyles = makeStyles((theme) => ({
    DashboardRoot: {
        display: 'flex',
        gap: '20px',
        justifyContent: 'center',
        [theme.breakpoints.down('md')]: {
            display: 'flex',
            justifyContent: 'flex-start',
        },
    },
    fromDateStyle: {
        width: '350px',
        overflow: 'hidden',

        [theme.breakpoints.down('md')]: {
            width: '310px',
            overflow: 'hidden',
        },
        [theme.breakpoints.between('md', 'xmd')]: {
            width: '250px',
            overflow: 'hidden',
        },
    },
    bridgeMatrixStyle: {
        display: 'flex',
        marginTop: '10px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '10px',
        [theme.breakpoints.between('md', 'xmd')]: {
            display: 'flex',
            marginTop: '10px',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '10px',
            width: 1090,
            overflow: 'auto',
        },
        [theme.breakpoints.between('lg', 'mlg')]: {
            display: 'flex',
            marginTop: '10px',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '10px',
            width: 1300,
            overflow: 'auto',
        },
    },
    toDateStyle: {
        width: '350px',
        overflow: 'hidden',

        [theme.breakpoints.down('md')]: {
            width: '310px',
            overflow: 'hidden',
        },
    },
    SearchEmployeeStyle: {
        width: 295,
        [theme.breakpoints.down('md')]: {
            width: 255,
        },
    },
    ChartRefDataStyle: {
        width: '990px',
        height: '990px',
        marginTop: '20px',
        padding: '10px',
        [theme.breakpoints.down('md')]: {
            width: '590px',
            height: '590px',
        },
        [theme.breakpoints.between('md', 'xmd')]: {
            width: '590px',
            height: '590px',
        },
    },
    ChartRefDataBox: {
        display: 'flex',
        [theme.breakpoints.down('md')]: {
            display: 'flex',
        },
    },
    paiChartDiv: {
        margin: '30px auto',
        marginTop: '50px',
        [theme.breakpoints.down('md')]: {
            display: 'flex',
            justifyContent: 'flex-start',
        },
    },
}));

// Styled container for the icon
const StyledIconContainer = styled(Stack)(({ theme }) => ({
    width: 40,
    height: 40,
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
}));
const Dashboard = () => {
    const classes = useStyles();
    const theme = useTheme();
    const chartRef = useRef(null);
    const chartRefData = useRef(null);

    const [chartData, setChartData] = useState(null);
    const [allUsers, setAllUsers] = React.useState([]);
    const [statusOverview, setStatusOverview] = React.useState({});
    const [selectedUserId, setSelectedUserId] = useState('');
    const [selectedUser, setSelectedUser] = useState(null);
    const [fromDate, setFromDate] = useState(dayjs().date(1));
    const [toDate, setToDate] = useState(dayjs());
    const [loading, setLoading] = React.useState(false);
    const [CountUser, setCountUser] = React.useState('');
    const [logOutModal, setLogOutModal] = React.useState(false);
    const [highestCount, setHighestCount] = React.useState();
    const [paiChartData, setPaiChartData] = useState();
    const [totalCountData, setTotalCountData] = useState();
    const [chartDataPie, setChartDataPie] = useState(null);
    const [selectedDate, setSelectedDate] = useState(dayjs());
    const [selectedDateStatusOverview, setSelectedDateStatusOverview] = useState('');
    const [bridgeMatrixData, setBridgeMatrixData] = useState([]);
    const [leadIN, setLeadIN] = useState('');

    const getPaiChartLeadStatus = async (selectedDateStatusOverview) => {
        try {
            setLoading(true);
            const formattedDate = dayjs(selectedDateStatusOverview).format('YYYY-MM');
            const res = await LeadService.GetLeadsCountByStatusDashboard(formattedDate);
            if (res?.data?.success) {
                setPaiChartData(res?.data?.leadsCount);
                setTotalCountData(res?.data?.totalLeadsCount);
            }
        } catch (error) {
            console.error(error.message);
            toast.error(error.message);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        getPaiChartLeadStatus(selectedDateStatusOverview);
    }, [selectedDateStatusOverview]);
    // pie chart
    let backgroundColors = {
        Agent: '#121212',
        'Appointment Set': '#00BF2A',
        'Attempting Contact': '#7400C2',
        'Bad Lead': '#ED7DB1',
        BAMFAM: '#6EA478',
        Cancelled: '#4C489B',
        Closed: '#6691CB',
        'Met with customer': '#0E4B37',
        'Not Interested': '#FEB065',
        'Nurture Before Sale': '#9B5B5B',
        'Nurture After Sale': '#DA5151',
        'Personal Lead': '#FEFE00',
        'Refinance Referral': '#008E6C',
        Rejected: '#7C0083',
        'Showing  Homes': '#F032E6',
        'Spoke with Customer': '#0000FE',
        'Buy Side Contract': '#FE4C00',
        New: '#FFC107',
        'Submitting Offers': '#00FE00',
        'Under Contract': '#AAFFC3',
        'Listing Under Contract': '#950E3F',
        'Follow Up': '#469990',
        'Listing Signed': '#C29800',
        Broker: '#FF0058',
        DNC: '#A87BFF',
        'Buyer Broker Signed': '#FABED4',
        'Valuation Apointment': '#7D9B00',
        Assigned: '#00FBFE',
        'Listing Appointment': '#CB5935',
    };
    let circleProgressColors = {
        Agent: '#121212',
        'Appointment Set': '#00bf2aa1',
        'Attempting Contact': '#7400c2a8',
        'Bad Lead': '#ed7db18a',
        BAMFAM: '#6ea478b8',
        Cancelled: '#4c489bb0',
        Closed: '#6691cbcf',
        'Met with customer': '#0e4b37d1',
        'Not Interested': '#FEB065',
        'Nurture Before Sale': '#9B5B5B',
        'Nurture After Sale': '#da5151d9',
        'Personal Lead': '#fefe009e',
        'Refinance Referral': '#008e6cb5',
        Rejected: '#7c0083b0',
        'Showing  Homes': '#F032E6',
        'Spoke with Customer': '#0000fe85',
        'Buy Side Contract': '#fe4c00ad',
        New: '#ffc107bd',
        'Submitting Offers': '#53eb53d6',
        'Under Contract': '#AAFFC3',
        'Listing Under Contract': '#950E3F',
        'Follow Up': '#469990d6',
        'Listing Signed': '#c29800c2',
        Broker: '#FF0058',
        DNC: '#A87BFF',
        'Buyer Broker Signed': '#FABED4',
        'Valuation Apointment': '#7D9B00',
        Assigned: '#00FBFE',
        'Listing Appointment': '#cb5935c9',
    };
    let statusLabelColors = {
        Agent: '#121212',
        'Appointment Set': '#00bf2aa1',
        'Attempting Contact': '#7400c2a8',
        'Bad Lead': '#ed7db18a',
        BAMFAM: '#6ea478b8',
        Cancelled: '#4c489bb0',
        Closed: '#6691cbcf',
        'Met with customer': '#0e4b37d1',
        'Not Interested': '#FEB065',
        'Nurture Before Sale': '#9B5B5B',
        'Nurture After Sale': '#da5151d9',
        'Personal Lead': '#c3c331',
        'Refinance Referral': '#008e6cb5',
        Rejected: '#7c0083b0',
        'Showing  Homes': '#F032E6',
        'Spoke with Customer': '#0000fe85',
        'Buy Side Contract': '#fe4c00ad',
        New: '#ffc107bd',
        'Submitting Offers': '#53eb53d6',
        'Under Contract': '#6fdb8f',
        'Listing Under Contract': '#950E3F',
        'Follow Up': '#469990d6',
        'Listing Signed': '#c29800c2',
        Broker: '#FF0058',
        DNC: '#A87BFF',
        'Buyer Broker Signed': '#FABED4',
        'Valuation Apointment': '#7D9B00',
        Assigned: '#00FBFE',
        'Listing Appointment': '#cb5935c9',
    };
    let backgroundColorsCard = {
        Agent: '#3e3e3e3d',
        'Appointment Set': '#23f95269',
        'Attempting Contact': '#6204a142',
        'Bad Lead': '#fd60a94a',
        BAMFAM: '#6ea47869',
        Cancelled: '#4c489b36',
        Closed: '#6691cb45',
        'Met with customer': '#0e4b3770',
        'Not Interested': '#feb06569',
        'Nurture Before Sale': '#9b5b5b4d',
        'Nurture After Sale': '#da51515e',
        'Personal Lead': '#d9d9155c',
        'Refinance Referral': '#008e6c82',
        Rejected: '#7c008352',
        'Showing Homes': '#f032e657',
        'Spoke with Customer': '#0000fe45',
        'Buy Side Contract': '#fe4c0063',
        New: '#c59a1870',
        'Submitting Offers': '#00fe0047',
        'Under Contract': '#256c398f',
        'Listing Under Contract': '#8d828226',
        'Follow Up': '#46999042',
        'Listing Signed': '#c298004f',
        Broker: '#c59a1870',
        DNC: '#a87bff4d',
        'Buyer Broker Signed': '#f786b047',
        'Valuation Appointment': '#7d9b0075',
        Assigned: '#00FBFE',
        'Listing Appointment': '#cb593557',
        'List Under Contract': '#5c2e2e9c',
    };
    const percentages = paiChartData?.map((lead) => {
        const percentage = (lead.status_count / totalCountData) * 100;
        const formattedPercentage = percentage.toFixed(2);
        return formattedPercentage;
    });

    useEffect(() => {
        const labels = paiChartData?.map((lead) => lead.status);
        const chartData = paiChartData?.map((lead) => lead.status_count);
        const backgroundColor = labels?.map((label) => backgroundColors[label]);

        const initialData = {
            labels: labels,
            datasets: [
                {
                    data: chartData,
                    backgroundColor: backgroundColor,
                    borderColor: 'white',
                    // borderRadius: 1,
                    borderWidth: 1,
                },
            ],
        };

        setChartDataPie(initialData);
    }, [paiChartData]);

    useEffect(() => {
        if (chartDataPie && chartRefData.current) {
            Chart.defaults.font.size = 12;
            Chart.defaults.font.weight = 'bold';
            const myChart = new Chart(chartRefData.current, {
                type: 'pie',
                data: chartDataPie,
                options: {
                    plugins: {
                        legend: {
                            display: false,
                        },
                        // title: {
                        //     display: true,
                        //     text: '',
                        //     position: 'top',
                        //     align: 'start',
                        //     font: {
                        //         size: 20,
                        //         weight: 'bold',
                        //     },
                        //     padding: 20,
                        // },
                        datalabels: {
                            color: 'black',
                            anchor: 'end',
                            align: 'end',
                            formatter: (value, context) => value,
                            font: {
                                weight: 'bold',
                                size: 12,
                            },
                        },
                    },
                    tooltip: {
                        mode: 'index',
                        intersect: false,
                        displayColors: false,
                        callbacks: {
                            label: function (context) {
                                var label = context.dataset.label || '';
                                if (label) {
                                    label += ': ';
                                }
                                if (context.parsed.y !== null) {
                                    label += context.parsed.y;
                                }
                                return label;
                            },
                        },
                        bodyFontColor: function (context) {
                            var dataset = context.dataset;
                            var index = context.dataIndex;
                            var value = dataset.data[index];
                            return dataset.backgroundColor[index];
                        },
                    },
                    layout: {
                        padding: {
                            left: 30,
                            right: 30,
                            top: 10,
                            bottom: 10,
                        },
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                },
            });

            return () => {
                myChart.destroy();
            };
        }
    }, [chartDataPie]);

    const clearState = async () => {
        setFromDate('');
        setToDate('');
        setSelectedUserId('');
        setSelectedUser(null);
        await getStatusesOverview();
    };

    useEffect(() => {
        // Define chart data
        const initialData = {
            labels: [
                'Appointment Set',
                'Met With Customer',
                'Showing Homes',
                'Submitting Offers',
                'Under Contract',
                'BAMFAM',
                'Nurture Before Sale',
                'Sale Closed',
                'Nurture After Sale',
                'Rejected',
                'Agent',
                'DNC',
                'Follow Up',
                'Buy Side Contract',
                'Listing Under Contract',
                'Listing Signed',
            ],

            datasets: [
                {
                    label: 'Highest Value',
                    data: [
                        statusOverview?.appointment_set || 0,
                        statusOverview?.met_with_customer || 0,
                        statusOverview?.showing_homes || 0,
                        statusOverview?.submitting_offers || 0,
                        statusOverview?.under_contract_escrow || 0,
                        statusOverview?.bamfam || 0,
                        statusOverview?.nurture || 0,
                        statusOverview?.closed || 0,
                        statusOverview?.nurture_after_sale || 0,
                        statusOverview?.rejected || 0,
                        statusOverview?.agent || 0,
                        statusOverview?.dnc || 0,
                        statusOverview?.follow_up || 0,
                        statusOverview?.buy_side_contract || 0,
                        statusOverview?.list_under_contract || 0,
                        statusOverview?.listing_signed || 0,
                    ],
                    backgroundColor: [
                        '#00BF2A',
                        '#7400C2',
                        '#ED7DB1',
                        '#6EA478',
                        '#4C489B',
                        '#6691CB',
                        '#FDCA40',
                        '#F17105',
                        '#9B5B5B',
                        '#ED0423',
                        '#121212',
                        '#A87BFF',
                        '#469990',
                        '#FE4C00',
                        '#950E3F',
                        '#C29800',
                    ],
                    borderWidth: 0,
                    borderRadius: 20,
                    categoryPercentage: 0.8,
                },
            ],
        };

        setChartData(initialData);
    }, [statusOverview]);
    useEffect(() => {
        if (chartData && chartRef.current) {
            Chart.defaults.font.size = 12;
            Chart.defaults.font.weight = 'bold';
            Chart.defaults.color = '#000';

            const myChart = new Chart(chartRef.current, {
                type: 'bar',
                data: chartData,
                options: {
                    plugins: {
                        datalabels: {
                            color: 'black',
                            anchor: 'end',
                            align: 'end',
                            formatter: (value, context) => value,
                            font: {
                                weight: 'bold',
                                size: 10,
                            },
                        },
                        tooltip: {
                            mode: 'index',
                            intersect: false,
                            displayColors: false,
                            callbacks: {
                                label: function (context) {
                                    var label = context.dataset.label || '';
                                    if (label) {
                                        label += ': ';
                                    }
                                    if (context.parsed.y !== null) {
                                        label += context.parsed.y;
                                    }
                                    return label;
                                },
                            },
                            bodyFontColor: function (context) {
                                var dataset = context.dataset;
                                var index = context.dataIndex;
                                var value = dataset.data[index];
                                return dataset.backgroundColor[index];
                            },
                        },
                        legend: {
                            display: false,
                            position: 'top',
                            labels: {
                                font: {
                                    size: 12,
                                    weight: 'bold',
                                },
                            },
                        },
                        // title: {
                        //     display: true,
                        //     text: 'Status Change',
                        //     position: 'top',
                        //     align: 'start',
                        //     font: {
                        //         size: 20,
                        //         weight: 'bold',
                        //     },
                        //     padding: 20,
                        // },
                    },
                    scales: {
                        y: {
                            beginAtZero: false,
                            min: 0,
                            max: highestCount || 100,
                        },
                        x: {
                            grid: {
                                display: false,
                            },
                        },
                    },
                    layout: {
                        padding: {
                            left: 30,
                            right: 30,
                            top: 10,
                            bottom: 10,
                        },
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                },
                plugins: [ChartDataLabels],
            });

            return () => {
                myChart.destroy();
            };
        }
    }, [chartData]);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear().toString();
        return `${day}-${month}-${year}`;
    };
    const handleSearchClick = async () => {
        // if (!selectedUserId) {
        //     toast.error('Please select any employee before searching.');
        //     return;
        // }
        if (fromDate) {
            if (!toDate) {
                toast.error('Please select the to date.');
                return;
            }
        }
        const currentDate = new Date();
        if (fromDate && new Date(fromDate) > currentDate) {
            toast.error('Please select a from date not later than the current date.');
            return;
        }
        if (toDate && fromDate && new Date(toDate) <= new Date(fromDate)) {
            toast.error('Please select a to date later than the start date.');
            return;
        }
        const formattedFromDate = fromDate ? formatDate(fromDate) : null;
        const formattedToDate = toDate ? formatDate(toDate) : null;
        console.log('From Date:', formattedFromDate);
        console.log('To Date:', formattedToDate);
        let searchParam = {
            user_id: selectedUserId,
            from_date: formattedFromDate,
            to_date: formattedToDate,
        };
        searchParam = Object.fromEntries(Object.entries(searchParam).filter(([_, v]) => v != null && v !== ''));
        const newData = await getStatusesOverview(searchParam);
        if (newData) {
            // Update the chart data with the new data
            setChartData((prevChartData) => ({
                ...prevChartData,
                datasets: [
                    {
                        ...prevChartData.datasets[0],
                        data: [
                            newData.appointment_set,
                            newData.met_with_customer,
                            newData.showing_homes,
                            newData.submitting_offers,
                            newData.under_contract_escrow,
                            newData.bamfam,
                            newData.nurture,
                            newData.closed,
                            newData.nurture_after_sale,
                            newData.rejected,
                        ],
                    },
                ],
            }));
        }
    };

    useEffect(() => {
        const formattedFromDate = fromDate ? formatDate(fromDate) : null;
        const formattedToDate = toDate ? formatDate(toDate) : null;
        let searchParam = {
            user_id: selectedUserId,
            from_date: formattedFromDate,
            to_date: formattedToDate,
        };
        searchParam = Object.fromEntries(Object.entries(searchParam).filter(([_, v]) => v != null && v !== ''));
        getStatusesOverview(searchParam);
    }, []);

    const getAllUserAdmin = async () => {
        try {
            const res = await LeadService.AllUsersSearchAdmin();
            if (res?.data?.success) {
                setAllUsers(res?.data?.users);
                return;
            }
        } catch (error) {
            console.error(error.message);
            if (error.message === 'You have been logged out of the application, please login again to use the application.') {
                setLogOutModal(true);
            } else {
                toast.error(error.message);
            }
        }
    };
    const handleUserSelect = (event, value) => {
        if (value) {
            setSelectedUserId(value?.id);
            setSelectedUser(value);
            console.log('Selected User ID:', value.id);
        } 
         else {
            setSelectedUserId('');
            setSelectedUser(null);
        }
    };

    const getStatusesOverview = async (searchParam) => {
        try {
            setLoading(true);
            const res = await LeadService.StatusesOverview(searchParam);
            if (res?.data?.success) {
                setStatusOverview(res?.data?.data);
                setHighestCount(res?.data?.highestCount);
                if (res?.data?.highestCount === 0) {
                    toast.success('No data found for the selected date range of bar chart. Please try a different start and end date.');
                } else {
                    // toast.success('Data found successfully');
                }
                return res?.data?.data;
            }
        } catch (error) {
            console.error(error.message);
            if (error.message === 'You have been logged out of the application, please login again to use the application.') {
                setLogOutModal(true);
            } else {
                toast.error(error.message);
            }
        } finally {
            setLoading(false);
        }
    };
    const getCountData = async () => {
        try {
            const res = await LeadService.TotalAllCountData();
            if (res?.data?.success) {
                setCountUser(res?.data?.data);
                return;
            }
        } catch (error) {
            console.error(error.message);
            if (error.message === 'You have been logged out of the application, please login again to use the application.') {
                setLogOutModal(true);
            } else {
                toast.error(error.message);
            }
        }
    };

    useEffect(() => {
        getAllUserAdmin();
        getStatusesOverview();
        getCountData();
    }, []);

    const getBridgeMatrix = async (selectedDate) => {
        try {
            const formattedDate = dayjs(selectedDate).format('YYYY-MM');
            const res = await LeadService.bridgeMatrix(formattedDate);

            if (res?.data?.success) {
                // Define the preferred order
                const preferredOrder = [
                    'Appointment Set',
                    'Met with customer',
                    'BAMFAM',
                    'BAMFAM Verified Yes',
                    'BAMFAM Verified Change',
                    'BAMFAM Verified No',
                    'Submitting Offers',
                    'Listing Signed',
                    'Under Contract',
                    'Buy Side Contract',
                    'Closed',
                ];

                // Filter the data to include only specific titles
                const filteredData = res?.data?.matrix_data.filter((item) => preferredOrder.includes(item?.title));

                // Sort the filtered data based on the preferred order
                const sortedData = filteredData.sort((a, b) => {
                    return preferredOrder.indexOf(a.title) - preferredOrder.indexOf(b.title);
                });

                // Set the sorted data to state
                setBridgeMatrixData(sortedData);
                setLeadIN(res?.data?.leads_in);
            }
        } catch (error) {
            toast.error(error.message);
        }
    };

    useEffect(() => {
        getBridgeMatrix(selectedDate);
    }, [selectedDate]);

    const statusImages = {
        Agent: Agent,
        'Appointment Set': AppointmentSet,
        'Attempting Contact': AttemptingContact,
        'Bad Lead': BadLead,
        BAMFAM: BamFam,
        Cancelled: Cancelled,
        Closed: Closed,
        'Met with customer': MetWithCustomer,
        'Not Interested': NotIntrested,
        'Nurture Before Sale': NurtureBeforeSale,
        'Nurture After Sale': NurtureAfterSale,
        'Personal Lead': PersonalLead,
        'Refinance Referral': RefinanceReferral,
        Rejected: Rejected,
        'Showing Homes': ShowingHomes,
        'Spoke with Customer': SpokeWithCustomer,
        'Buy Side Contract': BuySideContract,
        New: New,
        'Submitting Offers': SubmittingOffers,
        'Under Contract': UnderContract,
        'Listing Under Contract': ListingUnderContract,
        'Follow Up': FollowUp,
        'Listing Signed': ListingSigned,
        // Broker: Broker,
        DNC: DNC,
        'Buyer Broker Signed': BuyerBrokerSigned,
        'Valuation Appointment': ValuationAppointment,
        // Assigned: Assigned,
        'Listing Appointment': ListingAppointment,
        'List Under Contract': ListUnderContract,
    };

    return (
        <>
            <ThemeProvider theme={theme}>
                <GlobalStyles
                    styles={{
                        '::-webkit-scrollbar': {
                            width: '14px', // Set the desired width for the scrollbar
                            height: '14px',
                        },
                        '::-webkit-scrollbar-thumb': {
                            backgroundColor: '#c1c1c1', // Set the color for the scrollbar thumb
                            borderRadius: '10px', // Set the border radius for a rounded effect
                        },
                    }}
                />
                <Box>
                    <div>
                        <DashboardCards CountUser={CountUser} />
                    </div>

                    {/* bridge Matrix */}
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} md={12} lg={12} sx={{ marginTop: '40px' }}>
                            <Card
                                sx={{
                                    borderRadius: '22px',
                                    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                    padding: '20px',
                                }}
                            >
                                <Typography style={{ padding: '20px', paddingBottom: '0px', fontSize: '22px', fontWeight: 'bold', color: '#000' }}>
                                    Monthly Lead Status
                                </Typography>

                                {/* Month year Picker  Section*/}
                                <Grid container spacing={2}>
                                    <Grid item xs={3} sm={3} md={3} lg={3}></Grid>
                                    <Grid item xs={6} sm={6} md={6} lg={6} style={{ display: 'flex', justifyContent: 'center' }}>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DatePicker
                                                label="Select Month and Year"
                                                value={selectedDate}
                                                onChange={(newValue) => setSelectedDate(newValue)}
                                                views={['year', 'month']} // Show only year and month
                                                format="MMMM YYYY" // Customize display format (e.g., "November 2024")
                                                sx={{
                                                    width: 400,
                                                    '& .MuiOutlinedInput-root': {
                                                        borderRadius: '15px',
                                                    },
                                                }}
                                            />
                                        </LocalizationProvider>
                                    </Grid>
                                    <Grid item xs={3} sm={3} md={3} lg={3}></Grid>
                                </Grid>

                                {/* Lead IN Section */}
                                <Grid container spacing={2} style={{ marginTop: '12px' }}>
                                    <Grid item xs={4} sm={4} md={4} lg={4}></Grid>
                                    <Grid item xs={4} sm={4} md={4} lg={4}>
                                        <Card
                                            sx={{
                                                borderRadius: '20px',
                                                boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                                backgroundColor: 'white',
                                                height: '120px',
                                            }}
                                        >
                                            <CardContent>
                                                <Box sx={{ padding: '15px' }}>
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                        }}
                                                    >
                                                        <Avatar
                                                            sx={{
                                                                bgcolor: '#3867c1',
                                                                width: 40,
                                                                height: 40,
                                                            }}
                                                        >
                                                            <BarChartIcon />
                                                        </Avatar>
                                                        <Typography
                                                            sx={{
                                                                fontSize: { xs: '20px', sm: '24px', md: '26px', lg: '28px' }, // Responsive font sizes
                                                                fontWeight: 'bold',
                                                                color: '#233862',
                                                                fontFamily: 'inherit',
                                                            }}
                                                        >
                                                            {leadIN}
                                                        </Typography>
                                                    </Box>
                                                    <Box sx={{ marginTop: '20px' }}>
                                                        <Typography
                                                            sx={{
                                                                fontSize: {
                                                                    xs: '10px',
                                                                    sm: '14px',
                                                                    md: '16px',
                                                                    lg: '18px',
                                                                },
                                                                color: '#676b72',
                                                                fontWeight: 'bold',
                                                                fontFamily: 'inherit',
                                                            }}
                                                        >
                                                            Lead IN
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                    <Grid item xs={4} sm={4} md={4} lg={4}></Grid>
                                </Grid>

                                {/* Data Cards Section */}
                                <Grid
                                    container
                                    spacing={2}
                                    sx={{
                                        justifyContent: 'center',
                                        marginTop: '40px',
                                    }}
                                >
                                    <Box className={classes.bridgeMatrixStyle} style={{}}>
                                        <div style={{ display: 'flex', gap: '10px' }}>
                                            {bridgeMatrixData?.map((item, index) => {
                                                const { title } = item;
                                                if (title === 'Appointment Set') {
                                                    return (
                                                        <Box key={index}>
                                                            <Card
                                                                sx={{
                                                                    border: '1px solid #ccc',
                                                                    margin: '10px',
                                                                    padding: '15px',
                                                                    width: { xs: '120px', sm: '110px', md: '130px', lg: '150px', xl: '200px' }, // Responsive width
                                                                    height: { xs: '120px', sm: '110px', md: '130px', lg: '150px', xl: '200px' }, // Responsive height
                                                                    boxSizing: 'border-box',
                                                                    borderRadius: '50%', // Makes the card circular
                                                                    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                                                    cursor: 'pointer',
                                                                    background: '#00BF2A',
                                                                    transform: 'scale(1)',
                                                                    transition: 'transform 0.3s ease-in-out',
                                                                    display: 'flex', // Enables flexbox
                                                                    alignItems: 'center', // Vertically centers content
                                                                    justifyContent: 'center', // Horizontally centers content
                                                                    textAlign: 'center', // Centers text inside the card
                                                                    color: 'white', // White text for visibility
                                                                    fontWeight: 'bold', // Make text bold
                                                                }}
                                                                onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
                                                                onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                                            >
                                                                <Box>
                                                                    <Typography
                                                                        sx={{
                                                                            fontSize: { sm: '10px', md: '14px', lg: '16px' },
                                                                            fontWeight: { lg: 'bold' },
                                                                        }}
                                                                    >
                                                                        {item?.title}
                                                                    </Typography>{' '}
                                                                    <br />
                                                                    <Typography
                                                                        sx={{
                                                                            fontSize: { sm: '18px', md: '24px', lg: '26px' },
                                                                            fontWeight: { lg: 'bold' },
                                                                        }}
                                                                    >
                                                                        {item?.value}
                                                                    </Typography>
                                                                </Box>
                                                            </Card>
                                                        </Box>
                                                    );
                                                } else if (title === 'Met with customer') {
                                                    return (
                                                        <Box key={index}>
                                                            <Card
                                                                sx={{
                                                                    border: '1px solid #ccc',
                                                                    margin: '10px',
                                                                    padding: '15px',
                                                                    width: { xs: '120px', sm: '110px', md: '130px', lg: '150px', xl: '200px' }, // Responsive width
                                                                    height: { xs: '120px', sm: '110px', md: '130px', lg: '150px', xl: '200px' }, // Responsive height
                                                                    boxSizing: 'border-box',
                                                                    borderRadius: '50%', // Makes the card circular
                                                                    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                                                    background: '#147253',
                                                                    cursor: 'pointer',
                                                                    transform: 'scale(1)',
                                                                    transition: 'transform 0.3s ease-in-out',
                                                                    display: 'flex', // Enables flexbox
                                                                    alignItems: 'center', // Vertically centers content
                                                                    justifyContent: 'center', // Horizontally centers content
                                                                    textAlign: 'center', // Centers text inside the card
                                                                    color: 'white', // White text for visibility
                                                                    fontWeight: 'bold', // Make text bold
                                                                }}
                                                                onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
                                                                onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                                            >
                                                                <Box>
                                                                    <Typography
                                                                        sx={{
                                                                            fontSize: { sm: '10px', md: '14px', lg: '16px' },
                                                                            fontWeight: { lg: 'bold' },
                                                                        }}
                                                                    >
                                                                        {item?.title}
                                                                    </Typography>{' '}
                                                                    <br />
                                                                    <Typography
                                                                        sx={{
                                                                            fontSize: { sm: '18px', md: '24px', lg: '26px' },
                                                                            fontWeight: { lg: 'bold' },
                                                                        }}
                                                                    >
                                                                        {item?.value}
                                                                    </Typography>
                                                                </Box>
                                                            </Card>
                                                        </Box>
                                                    );
                                                } else if (title === 'BAMFAM') {
                                                    return (
                                                        <Box key={index}>
                                                            <Card
                                                                sx={{
                                                                    border: '1px solid #ccc',
                                                                    margin: '10px',
                                                                    padding: '15px',
                                                                    width: { xs: '120px', sm: '110px', md: '130px', lg: '150px', xl: '200px' }, // Responsive width
                                                                    height: { xs: '120px', sm: '110px', md: '130px', lg: '150px', xl: '200px' }, // Responsive height
                                                                    boxSizing: 'border-box',
                                                                    borderRadius: '50%', // Makes the card circular
                                                                    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                                                    background: '#458db5',
                                                                    cursor: 'pointer',
                                                                    transform: 'scale(1)',
                                                                    transition: 'transform 0.3s ease-in-out',
                                                                    display: 'flex', // Enables flexbox
                                                                    alignItems: 'center', // Vertically centers content
                                                                    justifyContent: 'center', // Horizontally centers content
                                                                    textAlign: 'center', // Centers text inside the card
                                                                    color: 'white', // White text for visibility
                                                                    fontWeight: 'bold', // Make text bold
                                                                }}
                                                                onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
                                                                onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                                            >
                                                                <Box>
                                                                    <Typography
                                                                        sx={{
                                                                            fontSize: { sm: '10px', md: '14px', lg: '16px' },
                                                                            fontWeight: { lg: 'bold' },
                                                                        }}
                                                                    >
                                                                        {item?.title}
                                                                    </Typography>{' '}
                                                                    <br />
                                                                    <Typography
                                                                        sx={{
                                                                            fontSize: { sm: '18px', md: '24px', lg: '26px' },
                                                                            fontWeight: { lg: 'bold' },
                                                                        }}
                                                                    >
                                                                        {item?.value}
                                                                    </Typography>
                                                                </Box>
                                                            </Card>
                                                        </Box>
                                                    );
                                                }
                                                // Add other conditions for the rest of the preferredOrder
                                                return null;
                                            })}
                                        </div>
                                        <Box>
                                            {bridgeMatrixData?.map((item, index) => {
                                                const { title } = item;

                                                // Assign different gradient colors based on the title
                                                const gradientBackground = {
                                                    'BAMFAM Verified Yes': '#174d1a', // Green gradient
                                                    'BAMFAM Verified Change': 'linear-gradient(135deg, #FFD700, #FF8C00)', // Yellow-orange gradient
                                                    'BAMFAM Verified No': 'linear-gradient(135deg, #FF5733, #C70039)', // Red gradient
                                                };

                                                if (
                                                    title === 'BAMFAM Verified Yes' ||
                                                    title === 'BAMFAM Verified Change' ||
                                                    title === 'BAMFAM Verified No'
                                                ) {
                                                    return (
                                                        <div key={index}>
                                                            <Card
                                                                sx={{
                                                                    border: '1px solid #ccc',
                                                                    margin: '10px',
                                                                    padding: '15px',
                                                                    width: { xs: '120px', sm: '110px', md: '130px', lg: '150px', xl: '200px' }, // Responsive width
                                                                    height: { xs: '120px', sm: '110px', md: '130px', lg: '150px', xl: '200px' }, // Responsive height
                                                                    boxSizing: 'border-box',
                                                                    borderRadius: '50%', // Makes the card circular
                                                                    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                                                    cursor: 'pointer',
                                                                    transform: 'scale(1)',
                                                                    transition: 'transform 0.3s ease-in-out',
                                                                    display: 'flex', // Enables flexbox
                                                                    alignItems: 'center', // Vertically centers content
                                                                    justifyContent: 'center', // Horizontally centers content
                                                                    textAlign: 'center', // Centers text inside the card
                                                                    background: gradientBackground[title], // Apply gradient based on the title
                                                                    color: 'white', // White text for visibility
                                                                    fontWeight: 'bold', // Make text bold
                                                                }}
                                                                onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
                                                                onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                                            >
                                                                <Box>
                                                                    <Typography
                                                                        sx={{
                                                                            fontSize: { sm: '10px', md: '14px', lg: '16px' },
                                                                            fontWeight: { lg: 'bold' },
                                                                        }}
                                                                    >
                                                                        {item?.title}
                                                                    </Typography>{' '}
                                                                    <br />
                                                                    <Typography
                                                                        sx={{
                                                                            fontSize: { sm: '18px', md: '24px', lg: '26px' },
                                                                            fontWeight: { lg: 'bold' },
                                                                        }}
                                                                    >
                                                                        {item?.value}
                                                                    </Typography>
                                                                </Box>
                                                            </Card>
                                                        </div>
                                                    );
                                                }

                                                return null;
                                            })}
                                        </Box>

                                        <Box style={{ display: 'flex', gap: '10px' }}>
                                            {bridgeMatrixData?.map((item, index) => {
                                                const { title } = item;

                                                // Assign different gradient colors based on the title
                                                const gradientBackground = {
                                                    'Submitting Offers': 'linear-gradient(135deg, rgb(255, 140, 0), rgb(93 134 229))', // Orange gradient
                                                };
                                                if (title === 'Submitting Offers') {
                                                    return (
                                                        <Box key={index}>
                                                            <Card
                                                                sx={{
                                                                    border: '1px solid #ccc',
                                                                    margin: '10px',
                                                                    padding: '15px',
                                                                    width: { xs: '120px', sm: '110px', md: '130px', lg: '150px', xl: '200px' }, // Responsive width
                                                                    height: { xs: '120px', sm: '110px', md: '130px', lg: '150px', xl: '200px' }, // Responsive height
                                                                    boxSizing: 'border-box',
                                                                    borderRadius: '50%', // Makes the card circular
                                                                    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                                                    cursor: 'pointer',
                                                                    transform: 'scale(1)',
                                                                    transition: 'transform 0.3s ease-in-out',
                                                                    display: 'flex', // Enables flexbox
                                                                    alignItems: 'center', // Vertically centers content
                                                                    justifyContent: 'center', // Horizontally centers content
                                                                    textAlign: 'center', // Centers text inside the card
                                                                    background: gradientBackground[title], // Apply gradient based on the title
                                                                    color: 'white', // Text color is white for visibility
                                                                    fontWeight: 'bold', // Bold text
                                                                }}
                                                                onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
                                                                onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                                            >
                                                                <Box>
                                                                    <Typography
                                                                        sx={{
                                                                            fontSize: { sm: '10px', md: '14px', lg: '16px' },
                                                                            fontWeight: { lg: 'bold' },
                                                                        }}
                                                                    >
                                                                        {item?.title}
                                                                    </Typography>{' '}
                                                                    <br />
                                                                    <Typography
                                                                        sx={{
                                                                            fontSize: { sm: '18px', md: '24px', lg: '26px' },
                                                                            fontWeight: { lg: 'bold' },
                                                                        }}
                                                                    >
                                                                        {item?.value}
                                                                    </Typography>
                                                                </Box>
                                                            </Card>
                                                        </Box>
                                                    );
                                                }
                                                return null;
                                            })}
                                        </Box>
                                        <Box>
                                            {bridgeMatrixData?.map((item, index) => {
                                                const { title } = item;
                                                // Assign different gradient colors based on the title
                                                const gradientBackground = {
                                                    'Listing Signed': '#c29800',
                                                    'Under Contract': '#81dc9c',
                                                    'Buy Side Contract': '#fe4c00',
                                                };
                                                if (title === 'Listing Signed' || title === 'Under Contract' || title === 'Buy Side Contract') {
                                                    return (
                                                        <div key={index}>
                                                            <Card
                                                                sx={{
                                                                    border: '1px solid #ccc',
                                                                    margin: '10px',
                                                                    padding: '15px',
                                                                    width: { xs: '120px', sm: '110px', md: '130px', lg: '150px', xl: '200px' }, // Responsive width
                                                                    height: { xs: '120px', sm: '110px', md: '130px', lg: '150px', xl: '200px' }, // Responsive height
                                                                    boxSizing: 'border-box',
                                                                    borderRadius: '50%', // Makes the card circular
                                                                    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                                                    cursor: 'pointer',
                                                                    transform: 'scale(1)',
                                                                    transition: 'transform 0.3s ease-in-out',
                                                                    display: 'flex', // Enables flexbox
                                                                    alignItems: 'center', // Vertically centers content
                                                                    justifyContent: 'center', // Horizontally centers content
                                                                    textAlign: 'center', // Centers text inside the card
                                                                    background: gradientBackground[title], // Apply gradient based on the title
                                                                    color: 'white', // White text for visibility
                                                                    fontWeight: 'bold', // Make text bold
                                                                }}
                                                                onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
                                                                onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                                            >
                                                                <Box>
                                                                    <Typography
                                                                        sx={{
                                                                            fontSize: { sm: '10px', md: '14px', lg: '16px' },
                                                                            fontWeight: { lg: 'bold' },
                                                                        }}
                                                                    >
                                                                        {item?.title}
                                                                    </Typography>{' '}
                                                                    <br />
                                                                    <Typography
                                                                        sx={{
                                                                            fontSize: { sm: '18px', md: '24px', lg: '26px' },
                                                                            fontWeight: { lg: 'bold' },
                                                                        }}
                                                                    >
                                                                        {item?.value}
                                                                    </Typography>
                                                                </Box>
                                                            </Card>
                                                        </div>
                                                    );
                                                }
                                                return null;
                                            })}
                                        </Box>
                                        <Box style={{ display: 'flex', gap: '10px' }}>
                                            {bridgeMatrixData?.map((item, index) => {
                                                const { title } = item;
                                                // Assign different gradient colors based on the title
                                                const gradientBackground = {
                                                    Closed: 'linear-gradient(135deg, #1E90FF, #00BFFF)', // Blue gradient
                                                };

                                                if (title === 'Closed') {
                                                    return (
                                                        <Box key={index}>
                                                            <Card
                                                                sx={{
                                                                    border: '1px solid #ccc',
                                                                    margin: '10px',
                                                                    padding: '15px',
                                                                    width: { xs: '120px', sm: '110px', md: '130px', lg: '150px', xl: '200px' }, // Responsive width
                                                                    height: { xs: '120px', sm: '110px', md: '130px', lg: '150px', xl: '200px' }, // Responsive height
                                                                    boxSizing: 'border-box',
                                                                    borderRadius: '50%', // Makes the card circular
                                                                    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                                                    cursor: 'pointer',
                                                                    transform: 'scale(1)',
                                                                    transition: 'transform 0.3s ease-in-out',
                                                                    display: 'flex', // Enables flexbox
                                                                    alignItems: 'center', // Vertically centers content
                                                                    justifyContent: 'center', // Horizontally centers content
                                                                    textAlign: 'center', // Centers text inside the card
                                                                    background: gradientBackground[title], // Apply gradient based on the title
                                                                    color: 'white', // Text color is white for visibility
                                                                    fontWeight: 'bold', // Bold text
                                                                }}
                                                                onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
                                                                onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                                            >
                                                                <Box>
                                                                    <Typography
                                                                        sx={{
                                                                            fontSize: { sm: '10px', md: '14px', lg: '16px' },
                                                                            fontWeight: { lg: 'bold' },
                                                                        }}
                                                                    >
                                                                        {item?.title}
                                                                    </Typography>{' '}
                                                                    <br />
                                                                    <Typography
                                                                        sx={{
                                                                            fontSize: { sm: '18px', md: '24px', lg: '26px' },
                                                                            fontWeight: { lg: 'bold' },
                                                                        }}
                                                                    >
                                                                        {item?.value}
                                                                    </Typography>
                                                                </Box>
                                                            </Card>
                                                        </Box>
                                                    );
                                                }

                                                return null;
                                            })}
                                        </Box>
                                    </Box>
                                </Grid>
                            </Card>
                        </Grid>
                    </Grid>

                    {/*  */}
                    <Card
                        style={{
                            borderRadius: '22px',
                            boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                            display: 'flex',
                            marginBottom: '40px',
                            marginTop: '40px',
                        }}
                    >
                        <Grid
                            container
                            spacing={2}
                            style={{
                                marginTop: '10px',
                                borderRadius: '22px',
                            }}
                        >
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <div style={{ display: 'flex' }}>
                                    <Typography style={{ padding: '20px', fontSize: '22px', fontWeight: 'bold', color: '#000' }}>
                                        Current Lead Status Overview
                                    </Typography>
                                    <CustomTooltip
                                        PopperProps={{
                                            modifiers: [
                                                {
                                                    name: 'offset',
                                                    options: {
                                                        offset: [-12, -10],
                                                    },
                                                },
                                            ],
                                        }}
                                        title="Overview of the Current Status of All Leads in the Database"
                                        placement="top-start"
                                    >
                                        <div style={{ marginTop: '25px' }}>
                                            <TipsAndUpdatesIcon style={{ fontSize: '18px' }} />
                                        </div>
                                    </CustomTooltip>
                                </div>
                            </Grid>
                            <Grid item xs={4} sm={4} md={4} lg={4}></Grid>
                            <Grid item xs={4} sm={4} md={4} lg={4} sx={{ marginTop: '0px' }}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label="Select Month and Year"
                                        value={selectedDateStatusOverview}
                                        onChange={(newValue) => setSelectedDateStatusOverview(newValue)}
                                        views={['year', 'month']} // Show only year and month
                                        format="MMMM YYYY" // Customize display format (e.g., "November 2024")
                                        sx={{
                                            width: 400,
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: '15px',
                                                // border: '1px solid black',
                                            },
                                        }}
                                    />
                                </LocalizationProvider>
                            </Grid>
                            <Grid item xs={4} sm={4} md={4} lg={4}></Grid>

                            <Grid item xs={12} sm={12} md={6} sx={{ marginTop: '20px' }}>
                                <Box style={{ borderRadius: '22px' }}>
                                    {/* <div style={{ display: 'flex', padding: '20px', gap: '10px' }}>
                                        <Typography style={{ fontWeight: 'bold', fontSize: '20px' }}>Current Lead Status Overview </Typography>
                                        <CustomTooltip
                                            PopperProps={{
                                                modifiers: [
                                                    {
                                                        name: 'offset',
                                                        options: {
                                                            offset: [-12, -10],
                                                        },
                                                    },
                                                ],
                                            }}
                                            title="Overview of the Current Status of All Leads in the Database"
                                            placement="top-start"
                                        >
                                            <div style={{ marginTop: '7px' }}>
                                                <TipsAndUpdatesIcon style={{ fontSize: '18px' }} />
                                            </div>
                                        </CustomTooltip>
                                    </div> */}
                                    <Box
                                        height={560}
                                        sx={{
                                            background: '#FFFFFF',

                                            margin: {
                                                md: '0px 20px',
                                            },
                                        }}
                                    >
                                        <canvas ref={chartRefData}></canvas>
                                    </Box>
                                </Box>
                            </Grid>

                            <Grid item xs={12} sm={12} md={6} sx={{ marginTop: '20px' }}>
                                <ScrollAnimation animateIn="fadeIn">
                                    <Box
                                        sx={{
                                            borderRadius: '22px',
                                            overflowY: 'auto',
                                            height: '560px',
                                        }}
                                    >
                                        {/* <div style={{ display: 'flex', padding: '20px', gap: '10px' }}>
                                            <Typography style={{ fontWeight: 'bold', fontSize: '20px' }}>Current Lead Status Overview </Typography>
                                            <CustomTooltip
                                                PopperProps={{
                                                    modifiers: [
                                                        {
                                                            name: 'offset',
                                                            options: {
                                                                offset: [-12, -10],
                                                            },
                                                        },
                                                    ],
                                                }}
                                                title="Overview of the Current Status of All Leads in the Database"
                                                placement="top-start"
                                            >
                                                <div style={{ marginTop: '7px' }}>
                                                    <TipsAndUpdatesIcon style={{ fontSize: '18px' }} />
                                                </div>
                                            </CustomTooltip>
                                        </div> */}
                                        <div style={{ padding: '20px' }}>
                                            <Grid container spacing={2}>
                                                {paiChartData?.map((status, index) => {
                                                    const statusColor = circleProgressColors[status.status] || 'gray';
                                                    const statusLabel = statusLabelColors[status.status] || 'gray';
                                                    const statusImage = statusImages[status.status] || null;
                                                    return (
                                                        <Grid item xs={12} sm={2.4} md={4} lg={3} key={index}>
                                                            <Card
                                                                style={{
                                                                    padding: '10px',
                                                                    border: '1px solid #ccc',
                                                                    borderRadius: '18px',
                                                                    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                                                    textAlign: 'center',
                                                                    cursor: 'pointer',
                                                                    transform: 'scale(1)',
                                                                    transition: 'transform 0.3s ease-in-out',
                                                                    background: '#FBFBFB',
                                                                }}
                                                                onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
                                                                onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                                            >
                                                                <div style={{ display: 'flex' }}>
                                                                    <div>
                                                                        <Avatar alt="AI" src={statusImage} />
                                                                    </div>
                                                                    <div style={{ width: 100, height: 100, margin: 'auto' }}>
                                                                        <CircularProgressbar
                                                                            value={percentages[index]}
                                                                            text={`${percentages[index]}%`}
                                                                            styles={buildStyles({
                                                                                textColor: statusLabel,
                                                                                pathColor: statusColor,
                                                                                textSize: '16px',
                                                                                fontWeight: 'bold',
                                                                                pathTransitionDuration: 0.5,
                                                                            })}
                                                                            strokeWidth={'14'}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <Box style={{ display: 'grid', justifyContent: 'flex-start', marginTop: '5px' }}>
                                                                    <Box style={{ display: 'flex', justifyContent: 'flex-start' }}>
                                                                        <Typography
                                                                            style={{ fontSize: '14px', fontWeight: 'bold', color: statusLabel }}
                                                                        >
                                                                            {status.status}
                                                                        </Typography>
                                                                    </Box>
                                                                    <Box style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '5px' }}>
                                                                        <div>
                                                                            <Typography style={{ fontSize: '14px', color: '#898484' }}>
                                                                                Number Count:
                                                                            </Typography>
                                                                        </div>
                                                                        <div style={{ display: 'flex' }}>
                                                                            <Typography
                                                                                style={{
                                                                                    fontSize: '12px',
                                                                                    color: '#605e5e',
                                                                                    marginLeft: '20px',
                                                                                    fontWeight: 'bold',
                                                                                }}
                                                                            >
                                                                                {status.status_count}
                                                                            </Typography>
                                                                        </div>
                                                                    </Box>
                                                                </Box>
                                                            </Card>
                                                        </Grid>
                                                    );
                                                })}
                                            </Grid>
                                        </div>
                                    </Box>
                                </ScrollAnimation>
                            </Grid>
                        </Grid>
                    </Card>
                    <Grid container spacing={0}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Card
                                style={{
                                    padding: '20px',
                                    borderRadius: '22px',
                                    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                }}
                            >
                                <Box style={{ display: 'flex', gap: '10px', marginTop: '10px', justifyContent: 'center' }}>
                                    <Box>
                                        <div>
                                            <Typography sx={{ fontWeight: 'bold' }}>From</Typography>
                                        </div>

                                        <div>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DemoContainer components={['DatePicker', 'DesktopDatePicker']}>
                                                    <DesktopDatePicker
                                                        className={classes.fromDateStyle}
                                                        sx={{
                                                            '.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                                borderColor: '#c1c1c1',
                                                            },
                                                            '.MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
                                                                borderColor: '#c1c1c1',
                                                            },

                                                            '& .MuiOutlinedInput-root': {
                                                                borderRadius: '15px',
                                                            },
                                                        }}
                                                        value={fromDate}
                                                        onChange={(newDate) => setFromDate(newDate)}
                                                    />
                                                </DemoContainer>
                                            </LocalizationProvider>
                                        </div>
                                    </Box>

                                    <Box>
                                        <div>
                                            <Typography sx={{ fontWeight: 'bold' }}>To</Typography>
                                        </div>
                                        <div>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DemoContainer components={['DatePicker', 'DesktopDatePicker']}>
                                                    <DesktopDatePicker
                                                        className={classes.toDateStyle}
                                                        sx={{
                                                            overflow: 'hidden',
                                                            '.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                                borderColor: '#c1c1c1',
                                                            },
                                                            '.MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
                                                                borderColor: '#c1c1c1',
                                                            },
                                                            '& .MuiOutlinedInput-root': {
                                                                borderRadius: '15px',
                                                            },
                                                        }}
                                                        value={toDate}
                                                        onChange={(newDate) => setToDate(newDate)}
                                                    />
                                                </DemoContainer>
                                            </LocalizationProvider>
                                        </div>
                                    </Box>
                                    <Box style={{ marginTop: '30px' }}>
                                        <Autocomplete
                                            disablePortal
                                            id="combo-box-demo"
                                            options={allUsers}
                                            getOptionLabel={(option) =>
                                                `${option?.name}${option?.last_name ? ` ${option?.last_name}` : ''}, (${option?.user_type === 'agent' ? 'Agent' : option?.user_type === 'isa_agent' ? 'ICA' : option?.user_type})`
                                            }
                                            value={selectedUser} // Control the Autocomplete value
                                            onChange={handleUserSelect}
                                            renderInput={(params) => <TextField {...params} label="Search Employee" />}
                                            className={classes.SearchEmployeeStyle}
                                            disabled={loading}
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    borderRadius: '15px',
                                                },
                                            }}
                                        />
                                    </Box>
                                    <Box style={{ display: 'flex', marginTop: '26px' }}>
                                        <Box
                                            style={{
                                                width: '56px',
                                                height: '50px',
                                                background: '#5c7dbd',
                                                cursor: 'pointer',
                                                borderRadius: '10px',
                                                marginTop: '6px',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                            }}
                                            onClick={handleSearchClick}
                                        >
                                            {loading ? (
                                                <CircularProgress sx={{ color: 'white' }} />
                                            ) : (
                                                <SearchIcon
                                                    style={{
                                                        color: 'white',
                                                        margin: '12px',
                                                        fontSize: '41px',
                                                        cursor: 'pointer',
                                                    }}
                                                />
                                            )}
                                        </Box>
                                        <Box>
                                            <Button
                                                style={{
                                                    width: 'auto',
                                                    height: '40px',
                                                    border: '1px solid gray',
                                                    background: '#bababa',
                                                    borderRadius: '8px',
                                                    fontWeight: 'bold',
                                                    marginLeft: '5px',
                                                    cursor: 'pointer',
                                                    marginTop: '10px',
                                                    marginBottom: 'px',
                                                    color: 'black',
                                                }}
                                                sx={{ fontFamily: 'inherit' }}
                                                onClick={clearState}
                                            >
                                                Clear
                                            </Button>
                                        </Box>
                                    </Box>
                                </Box>
                                {/*  */}
                                <Grid container spacing={0}>
                                    <Grid item xs={12} sm={12} md={12} sx={{ marginTop: '10px' }}>
                                        <ScrollAnimation animateIn="fadeIn">
                                            <Box>
                                                <div style={{ display: 'flex', padding: '20px', gap: '10px' }}>
                                                    <Typography style={{ fontWeight: 'bold', fontSize: '20px' }}> Status Change</Typography>
                                                    <CustomTooltip
                                                        PopperProps={{
                                                            modifiers: [
                                                                {
                                                                    name: 'offset',
                                                                    options: {
                                                                        offset: [-22, -10],
                                                                    },
                                                                },
                                                            ],
                                                        }}
                                                        title="Summary of Overall Status Changes in the Database"
                                                        placement="top-start"
                                                    >
                                                        <div style={{ marginTop: '7px' }}>
                                                            <TipsAndUpdatesIcon style={{ fontSize: '18px' }} />
                                                        </div>
                                                    </CustomTooltip>
                                                </div>
                                                <Box height={475}>
                                                    <canvas ref={chartRef}></canvas>
                                                </Box>
                                            </Box>
                                        </ScrollAnimation>
                                    </Grid>
                                </Grid>
                            </Card>
                        </Grid>
                    </Grid>
                    <LogoutExpiredModal setLogOutModal={setLogOutModal} logOutModal={logOutModal} />
                </Box>
            </ThemeProvider>
        </>
    );
};

export default Dashboard;
